export default __webpack_public_path__ + "static/media/section-videos.056cfec9.webp";